import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'VenueBlockedDates';

const VenueBlockedDatesApi: any = baseApi(endpoint);

export default VenueBlockedDatesApi;